import React, { Component } from "react";
import {
  Modal,
  Card,
  Col,
  Row,
  Form,
  Button,
  Table,
  Spinner,
} from "react-bootstrap-v5";
import "react-bootstrap-typeahead/css/Typeahead.css";
import { toast } from "react-toastify";
import EditCost from "./EditCost";
import Currency from "../../../../Function/currency.json";
import { revenuecostService } from "../../../../Services/revenuecostService";
import { FaTrashAlt, FaEdit } from "react-icons/fa";
import helperFunction from "../../../../Function/helperFunction";

const DeleteModal = ({
  modalShow,
  handleDeleteShow,
  handleDelete,
  showDeleteLoader,
}) => {
  return (
    <Modal
      size="sm"
      show={modalShow}
      onHide={() => handleDeleteShow(false)}
      aria-labelledby="example-modal-sizes-title-lg"
    >
      <Modal.Header closeButton>
        <Modal.Title id="example-modal-sizes-title-lg">
          Delete Cost?
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>Do you want to delete this cost?</Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => handleDeleteShow(false)}>
          Close
        </Button>
        <Button variant="primary" onClick={() => handleDelete()}>
          {showDeleteLoader ? (
            <Spinner
              as="span"
              animation="grow"
              size="sm"
              role="status"
              aria-hidden="true"
            />
          ) : (
            "Yes"
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

class Cost extends Component {
  state = {
    showEditCostModal: false,
    showDeleteModal: false,
    showDeleteLoader: false,
    deletedCostItem: { item: null, index: 0 },
    costIndex: 0,
    costObj: {
      item_name: "",
      rate_per_qty: "",
      type: "",
      qbook_service: "",
      qbook_vendor: "",
      description: "",
      invoice_number: "",
      currency: "AED",
      ex_rate: 1,
      lc_amount: "",
      vat_amount: "",
      vat: 2,
      glc_amount: "",
      remark: "",
    },
    cost: [],
    vendors: [],
    buttonSubmit: true,
    costItems: [
      {
        item_name: "",
        rate_per_qty: "",
        type: "",
        qbook_service: "",
        qbook_vendor: "",
        description: "",
        invoice_number: "",
        currency: "AED",
        ex_rate: 1,
        lc_amount: "",
        vat_amount: "",
        vat: 2,
        glc_amount: "",
      },
    ],
  };

  componentDidMount() {
    this.getCosts();
    this.getVendors();
  }

  getCosts = () => {
    let jId = this.props.jobId;
    jId &&
      revenuecostService.getCost({ jId }).then((result) => {
        if (result.status === true) {
          let data = result.data;
          let findCost= data.length>0 ? data.map((item)=> item.draft).includes(true) ? true : false : true
          // let findCost= result?.data.find(
          //   (item) => item.draft === true
          // )
        this.props.checkCost(findCost)
          for (let i = 0; i < data.length; i++) {
            data[i].qbook_vendor =
              data[i].qbook_vendor + "_" + data[i].qbook_vendor_name;
            data[i].glc_amount = data[i].gross_amount;
          }
          this.setState({ cost: data });
        }
      });
  };

  getVendors = () => {
    revenuecostService.getVendors().then((result) => {
      if (result.status === true) {
        this.setState({ vendors: result.data });
      }
    });
  };

  handleInputChange(e, index = "") {
    const { name, value } = e.target;
    let rObj = this.state.costObj;
    let cArray = this.state.costItems;

    if (index !== "") {
      cArray[index][name] = value;
      if (name === "item_name") {
        cArray[index]["description"] = value;
      }

      if (name === "rate_per_qty") {
        let exrate = cArray[index].ex_rate;
        let vat = cArray[index].vat;
        let vatPer = vat === "5" ? 5 : 0;
        let lcAmt = Number((exrate * value).toFixed(2));
        let vatAmt = 0;
        if (vatPer !== 0) {
          vatAmt = ((lcAmt * vatPer) / 100).toFixed(2);
          rObj.vat_amount = vatAmt;
          cArray[index]["vat_amount"] = vatAmt;
        } else {
          rObj.vat_amount = vatAmt;
          cArray[index]["vat_amount"] = vatAmt;
        }
        rObj.lc_amount = lcAmt;
        rObj.glc_amount = Number(lcAmt) + Number(cArray[index].vat_amount);

        cArray[index]["lc_amount"] = lcAmt;
        cArray[index]["glc_amount"] = Number(lcAmt) + Number(rObj.vat_amount);
      }

      if (name === "ex_rate") {
        let rpq = cArray[index].rate_per_qty;
        let vat = cArray[index].vat;
        let vatPer = vat === "5" ? 5 : 0;
        let lcAmt = Number((rpq * value).toFixed(2));
        let vatAmt = 0;

        if (vatPer !== 0) {
          vatAmt = ((lcAmt * vatPer) / 100).toFixed(2);
          // cArray[index].vat_amount = vatAmt
        }
        //  let vatAmt = (lcAmt * vat) / 100 //remove comment getting error10-02-23

        rObj.vat_amount = vatAmt;
        rObj.lc_amount = lcAmt;
        rObj.ex_rate = value;
        rObj.glc_amount = Number(lcAmt) + Number(vatAmt);

        cArray[index]["lc_amount"] = lcAmt;
        cArray[index]["glc_amount"] = Number(lcAmt) + Number(vatAmt);
        cArray[index]["vat_amount"] = vatAmt;
      }

      if (name === "vat" && value !== 0) {
        let lcAmt = rObj.lc_amount;
        let vatPer = value === "5" ? 5 : 0;
        let gcAmtPercent = 0;
        if (vatPer === 0) {
          gcAmtPercent = 0;
        } else {
          gcAmtPercent = ((lcAmt * vatPer) / 100).toFixed(2);
        }
        let gcAmt = Number(gcAmtPercent) + Number(lcAmt);
        rObj.glc_amount = gcAmt;
        rObj.vat_amount = Number(gcAmtPercent);

        // cArray[index]["vat"] = value; //code apply by s
        cArray[index]["glc_amount"] = gcAmt;
        cArray[index]["vat_amount"] = Number(gcAmtPercent);
      }
    } else {
      rObj[name] = value;
    }
    this.setState({ costObj: rObj, costItems: cArray });
  }

  // append cost item function

  handleAddItem = () => {
    let costCloneObj = this.state.costObj;
    let item = [...this.state.costItems];
    item.push(costCloneObj);
    this.setState({ costItems: item });
  };

  // remove cost item function

  handleRemoveItem = () => {
    this.setState({ showDeleteLoader: true });
    const { deletedCostItem } = this.state;
    if (
      deletedCostItem?.item?.bill_data &&
      deletedCostItem.item.bill_data.Bill.Id &&
      deletedCostItem.item.draft === false
    ) {
      revenuecostService
        .deleteBill({
          id: deletedCostItem.item.bill_data.Bill.Id,
          SyncToken: deletedCostItem.item.bill_data.Bill.SyncToken,
        })
        .then((result) => {
          if (result.status) {
            this.removeCost();
          } else {
            console.log("error");
          }
        });
    } else {
      this.removeCost();
    }
  };
  removeCost = () => {
    const { deletedCostItem } = this.state;
    this.handleDeleteShow(false);
    revenuecostService
      .deleteCost({ id: deletedCostItem.item._id })
      .then((res) => {
        this.setState({ showDeleteLoader: false });
        const itemListClone = [...this.state.costItems];
        itemListClone.splice(deletedCostItem.index, 1);
        // this.setState({ costItems: itemListClone });
        this.props.profitNLoss();
        this.getCosts();
      });
  };

  handleUpdateStatus(e, id) {
    const { name, value } = e.target;
    let postData = {};
    postData.id = id;
    postData.status = value;

    revenuecostService.updateCostStatus(postData).then((result) => {
      if (result.status === true) {
        toast.success(result.message);
        this.getCosts();
      }
    });
  }

  addtoQuickBook = (costItems) => {
    this.setState({ buttonSubmit: false });
    let postData = costItems;
    postData.job_id = this.props.jobId;
    postData.job_token = this.props.jobToken;
    postData.customer_email = this.props.customerData.email;
    postData.gross_amount = postData.glc_amount;
    postData.remark = this.state.costObj.remark;
    let qb = postData.qbook_vendor.split("_");
    postData.qbook_vendor = qb.length && qb[0];
    postData.qbook_vendor_name = qb.length && qb[1];
    postData.id = postData._id;
    revenuecostService.billCreateQB(postData).then((result) => {
      if (result.status === true) {
        // let vatPer = postData.vat === "5" ? 5 : 0;
        // postData.vat = vatPer;
        postData.bill_data = { ...result.data };
        postData.draft = false;
        revenuecostService.updateCostStatus(postData).then((result) => {
          this.setState({ buttonSubmit: true });
          if (result.status === true) {
            toast.success(result.message);
            this.getCosts();
            this.props.profitNLoss();
          }
        });
      } else {
        toast.error(result.data.error);
        this.setState({ buttonSubmit: true });
      }
    });
  };

  createCost = () => {
    let postData = this.state.costItems[0];
    if(!postData?.item_name || !postData?.qbook_vendor || !postData?.glc_amount) return false
    this.setState({ buttonSubmit: false });
    postData.job_id = this.props.jobId;
    postData.job_token = this.props.jobToken;
    postData.customer_email = this.props.customerData.email;
    postData.gross_amount = postData.glc_amount;
    postData.remark = this.state.costObj.remark;
    let qb = postData.qbook_vendor.split("_");
    postData.qbook_vendor = qb.length && qb[0];
    postData.qbook_vendor_name = qb.length && qb[1];
    postData.draft = true;
    if(this.state.costObj?.created_date) postData.created_date = this.state.costObj?.created_date;

    //  return;
    // revenuecostService.billCreateQB(postData).then(result => {
    //     if (result.status === true) {
    //         let vatPer = postData.vat === "5" ? 5 : 0;
    //         postData.vat = vatPer;
    //         postData.bill_data = { ...result.data }
    revenuecostService.createCost(postData).then((result) => {
      if (result.status === true) {
        toast.success(result.message);
        this.getCosts();
        this.props.profitNLoss();
        this.setState({
          costObj: {
            item_name: "",
            rate_per_qty: "",
            type: "",
            qbook_service: "",
            qbook_vendor: "",
            description: "",
            invoice_number: "",
            currency: "AED",
            ex_rate: 1,
            lc_amount: "",
            vat_amount: "",
            vat: 2,
            glc_amount: "",
            remark: "",
          },
          buttonSubmit: true,
          costItems: [
            {
              item_name: "",
              rate_per_qty: "",
              type: "",
              qbook_service: "",
              qbook_vendor: "",
              description: "",
              invoice_number: "",
              currency: "AED",
              ex_rate: 1,
              lc_amount: "",
              vat_amount: "",
              vat: 2,
              glc_amount: "",
            },
          ],
        });
      } else {
        this.setState({ buttonSubmit: true });
      }
    });
    //     } else {
    //         toast.error(result.data.error)
    //         this.setState({ buttonSubmit: true })
    //     }
    // })
  };

  handleShowEditCost = (value, index) => {
    if (value === true) {
      this.setState({ showEditCostModal: value, costIndex: index });
    } else {
      this.setState({ showEditCostModal: value });
    }
  };

  handleDeleteShow = (value) => {
    this.setState({ showDeleteModal: value });
  };

  render() {
    const { cost, vendors, costObj, buttonSubmit, costItems } = this.state;
    // if (!jobData || Object.keys(jobData).length === 0) return false
    // if (!customerData || Object.keys(customerData).length === 0) return false


    return (
      <Card>
        <div className="card-header bg-light">
          <h4>Cost Information</h4>
        </div>
        <Card.Body>
          <Row style={{ overflow: "auto" }}>
            <Table bordered size="sm">
              <thead>
                <tr>
                  <th>JOB ITEM</th>
                  <th>DESCRIPTION</th>
                  <th>ACC TYPE</th>
                  <th>ACC NAME</th>
                  <th>INV #</th>
                  <th>CURRENCY</th>
                  <th>FC Amount</th>
                  <th>Ex Rate</th>
                  <th>LC Amount</th>
                  <th>VAT%</th>
                  <th>VAT AMOUNT</th>
                  <th>Gross LC Amount</th>
                  <th>REMARKS</th>
                  <th>#</th>
                </tr>
              </thead>
              <tbody>
                {cost &&
                  cost.length > 0 &&
                  cost.map((item, i) => {
                    return (
                      <tr key={i} style={{backgroundColor:`${item.draft ? 'white' : "rgb(214 206 142)"}`}}>
                        <td>{item.item_name}</td>
                        <td>{item.description}</td>
                        <td>{item.type}</td>
                        <td>{item.qbook_vendor_name}</td>
                        <td>{item.invoice_number}</td>
                        <td>{item.currency}</td>
                        <td>{item.rate_per_qty}</td>
                        <td>{item.ex_rate}</td>
                        <td>{item.lc_amount}</td>
                        <td>{item.vat}</td>
                        <td>{item.vat_amount}</td>
                        <td>
                          {item?.gross_amount &&
                            helperFunction.handleDecimalPoints(
                              item.gross_amount,
                              3
                            )}
                        </td>
                        <th>{item.remark}</th>
                        <th>
                          <div className="d-flex align-items-center ">
                            {item.draft && !this.props.isview && (
                              <Button
                                variant="success"
                                onClick={() => this.addtoQuickBook(item)}
                                className="m-1 p-1 fs-5"
                              >
                                QB
                              </Button>
                            )}

                            {
                              !this.props.isview &&
                            <Button
                              variant="warning"
                              className="m-1"
                              onClick={() => this.handleShowEditCost(true, i)}
                            >
                              <FaEdit />
                            </Button>
                            }

                            {
                              !this.props.isview &&
                            <Button
                              className="m-1 p-2"
                              variant="danger"
                              size="sm"
                              onClick={() => {
                                this.handleDeleteShow(true);
                                this.setState({
                                  deletedCostItem: { item: item, index: i },
                                });
                              }}
                              // onClick={() => this.handleRemoveItem(item, i)}
                            >
                              <FaTrashAlt />
                            </Button>
                            }
                          </div>
                        </th>
                      </tr>
                    );
                  })}
              </tbody>
            </Table>
          </Row>

          <div className="_cost_listing">
            {costItems &&
              costItems.length > 0 &&
              costItems.map((item, key) => {
                return (
                  <Row className="customNoLineBreak" key={key}>
                    <Col>
                      <Form.Group className="mb-3">
                        <Form.Label>Select Job Item</Form.Label>
                        <Form.Select
                          name="item_name"
                          value={item.item_name}
                          onChange={(e) => this.handleInputChange(e, key)}
                        >
                          <option value="">Select</option>
                          <option value="AIR FREIGHT CHARGES">
                            AIR FREIGHT CHARGES
                          </option>
                          <option value="SEA FREIGHT CHARGES">
                            SEA FREIGHT CHARGES
                          </option>
                          <option value="LAND FREIGHT CHARGES">
                            LAND FREIGHT CHARGES
                          </option>
                          <option value="COURIER CHARGES">
                            COURIER CHARGES
                          </option>
                          <option value="LOCAL TRANSPORTATION">
                            LOCAL TRANSPORTATION
                          </option>
                          <option value="PACKING CHARGES">
                            PACKING CHARGES
                          </option>
                          <option value="INSURANCE PREMIUM">
                            INSURANCE PREMIUM
                          </option>
                          <option value="STORAGES CHARGES">
                            STORAGES CHARGES
                          </option>
                          <option value="OTHER SERVICES">OTHER SERVICES</option>
                        </Form.Select>
                      </Form.Group>
                    </Col>
                    <Col>
                      <Form.Group className="mb-3">
                        <Form.Label>Description</Form.Label>
                        <Form.Control
                          name="description"
                          value={item.description}
                          onChange={(e) => this.handleInputChange(e, key)}
                        />
                      </Form.Group>
                    </Col>
                    <Col>
                      <Form.Group className="mb-3">
                        <Form.Label>Acc Type</Form.Label>
                        <Form.Select
                          aria-label="Default select example"
                          name="type"
                          onChange={(e) => this.handleInputChange(e, key)}
                          value={item.type}
                        >
                          <option>Select Type</option>
                          <option value="customer">Customer</option>
                          <option value="service_partner">
                            Service Partner
                          </option>
                          <option value="vendor">Vendor</option>
                          <option value="cash">Cash</option>
                        </Form.Select>
                      </Form.Group>
                    </Col>

                    <Col>
                      <Form.Group className="mb-3">
                        <Form.Label>ACC NAME</Form.Label>
                        <Form.Select
                          aria-label="Vendors list"
                          name="qbook_vendor"
                          onChange={(e) => this.handleInputChange(e, key)}
                          value={item.qbook_vendor}
                        >
                          <option>Select Vendor</option>
                          {vendors.length &&
                            vendors.map((item,i) => {
                              return (
                                <option key={i}
                                  value={`${item.quickBookRef.userid}_${item.business_name}`}
                                >
                                  {item.business_name}
                                </option>
                              );
                            })}
                        </Form.Select>
                      </Form.Group>
                    </Col>
                    <Col>
                      <Form.Group className="mb-3">
                        <Form.Label>Invoice NO.</Form.Label>
                        <Form.Control
                          name="invoice_number"
                          value={item.invoice_number}
                          onChange={(e) => this.handleInputChange(e, key)}
                        />
                      </Form.Group>
                    </Col>

                    <div className="px-2" style={{ maxWidth: 130 }}>
                      <Form.Group className="mb-3">
                        <Form.Label>Currency </Form.Label>
                        <Form.Select
                          name="currency"
                          onChange={(e) => this.handleInputChange(e, key)}
                          value={item.currency}
                        >
                          <option>Currency</option>

                          {Currency.map((item,i) => {
                            return (
                              <option key={i} value={item.cc}>
                                {item.cc}
                                {/* ({item.symbol}) */}
                              </option>
                            );
                          })}
                        </Form.Select>
                      </Form.Group>
                    </div>
                    <div className="px-2" style={{ maxWidth: 90 }}>
                      <Form.Group className="mb-3">
                        <Form.Label>FC Amount</Form.Label>
                        <Form.Control
                          name="rate_per_qty"
                          value={item.rate_per_qty}
                          onChange={(e) => this.handleInputChange(e, key)}
                        />
                      </Form.Group>
                    </div>

                    <div className="px-2" style={{ maxWidth: 90 }}>
                      <Form.Group className="mb-3">
                        <Form.Label>Ex Rate</Form.Label>
                        <Form.Control
                          name="ex_rate"
                          value={item.ex_rate}
                          onChange={(e) => this.handleInputChange(e, key)}
                        />
                      </Form.Group>
                    </div>

                    <Col>
                      <Form.Group className="mb-3">
                        <Form.Label>LC Amount</Form.Label>
                        <Form.Control
                          name="lc_amount"
                          value={item.lc_amount}
                          onChange={(e) => this.handleInputChange(e, key)}
                          readOnly
                        />
                      </Form.Group>
                    </Col>

                    <div className="px-2" style={{ maxWidth: 90 }}>
                      <Form.Group className="mb-3">
                        <Form.Label>Vat</Form.Label>
                        <Form.Select
                          name="vat"
                          onChange={(e) => this.handleInputChange(e, key)}
                        >
                          {/* <option value={0}>Zero-Rated</option>
                                                    <option value={5}>Exempt From VAT</option>
                                                    <option value={10}>SR Standard Rated (DXB) SS-DXB</option> */}
                          <option value={2}>Zero-Rated</option>
                          <option value={4}>Exempt From VAT</option>
                          <option value={5}>SR Standard Rated</option>
                        </Form.Select>
                      </Form.Group>
                    </div>

                    <Col>
                      <Form.Group className="mb-3">
                        <Form.Label>Vat Amount</Form.Label>
                        <Form.Control
                          name="vat_amount"
                          value={item.vat_amount}
                          onChange={(e) => this.handleInputChange(e, key)}
                          readOnly
                        />
                      </Form.Group>
                    </Col>

                    <Col>
                      <Form.Group className="mb-3">
                        <Form.Label>Gross LC Amount</Form.Label>
                        <Form.Control
                          name="glc_amount"
                          value={item.glc_amount}
                          onChange={(e) => this.handleInputChange(e, key)}
                          readOnly
                        />
                      </Form.Group>
                    </Col>

                    {/* <div className="px-2" style={{ maxWidth: 80 }}>
                                            <Button
                                                className="mt-4"
                                                variant="danger"
                                                size="sm"
                                                onClick={() => this.handleRemoveItem(key)}
                                            >
                                                <FaTrashAlt />
                                            </Button>
                                        </div> */}

                    {/* <Col>
                            <Form.Group className="mb-3">
                                <Form.Label>Status</Form.Label>
                                <Form.Select aria-label="Default select example" name="status" onChange={(e) => this.handleInputChange(e)} value={costObj.status}>
                                    <option>Select status</option>
                                    <option value="paid">Paid</option>
                                    <option value="unpaid">Unpaid</option>
                                </Form.Select>
                            </Form.Group>
                        </Col> */}
                  </Row>
                );
              })}

            {/* <Row>
                            <Col md={2} className="mt-3">
                                <Button
                                    variant="success"
                                    size="sm"
                                    onClick={() => this.handleAddItem()}
                                >
                                    Add Item
                                </Button>
                            </Col>
                        </Row> */}
          </div>

          <Row className="mt-3">
            {/* <Col md={2}>
              <div className="col-12">
                <div className="">
                  <label className="form-label">Date</label>
                  <input
                    className="form-control form-control-sm"
                    name="created_date"
                    type="date"
                    value={costObj?.created_date}
                    onChange={(e) => this.handleInputChange(e, "")}
                  />
                </div>
              </div>
            </Col> */}
            <Col md={6}>
              <div className="col-12">
                <div className="">
                  <label className="form-label">Remark</label>
                  <textarea
                    className="form-control form-control-sm"
                    name="remark"
                    value={costObj?.remark}
                    onChange={(e) => this.handleInputChange(e, "")}
                  />
                </div>
              </div>
            </Col>
            <Col md={2} className="mt-4">
              {buttonSubmit && !this.props.isview && (
                <Button variant="warning" onClick={() => this.createCost()}>
                  Add Cost
                </Button>
              )}
              {!buttonSubmit && (
                <Button variant="primary" disabled>
                  <Spinner
                    as="span"
                    animation="grow"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                  Loading...
                </Button>
              )}
            </Col>
              {/* {costItems &&
                costItems.map((itm, index) => {
            return(
                  !itm.draft && 
            <Col md={2} className="mt-4">
                  <Button>Financial Close</Button>
            </Col>)
                })} */}
          </Row>

          {cost && cost.length > 0 && (
            <Modal
              size="lg"
              show={this.state.showEditCostModal}
              onHide={() => this.handleShowEditCost(false)}
              aria-labelledby="example-modal-sizes-title-lg"
            >
              <Modal.Header closeButton>
                <Modal.Title id="example-modal-sizes-title-lg">
                  Cost
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <EditCost
                  handleShowEditCost={this.handleShowEditCost}
                  costItem={[cost[this.state.costIndex]]}
                  costObj={this.state.costObj}
                  vendorList={this.state.vendors}
                  quoteToken={this.props.quoteToken}
                  jobId={this.props.jobId}
                  getCosts={this.getCosts}
                  customerData={this.props.customerData.email}
                  profitNLoss={this.props.profitNLoss}
                />
              </Modal.Body>
            </Modal>
          )}
          {this.state.showDeleteModal && (
            <DeleteModal
              modalShow={this.state.showDeleteModal}
              handleDeleteShow={this.handleDeleteShow}
              handleDelete={this.handleRemoveItem}
              showDeleteLoader={this.state.showDeleteLoader}
            />
          )}
        </Card.Body>
      </Card>
    );
  }
}

export default Cost;
